import { render } from "./opening-button.vue?vue&type=template&id=cc0c3e2a"
import script from "./opening-button.vue?vue&type=script&lang=js"
export * from "./opening-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__